import React, { useEffect } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "../Css/NotFound.css";

export function NotFound() {
    const navigate = useNavigate();

    // The server answers every address with the app (HTTP 200), so tell search
    // engines not to index this page; otherwise Google reports it as a "soft 404"
    useEffect(() => {
        const previousTitle = document.title;
        document.title = "Page not found | Smart Task Software";

        const robots = document.createElement("meta");
        robots.name = "robots";
        robots.content = "noindex";
        document.head.appendChild(robots);

        return () => {
            document.title = previousTitle;
            robots.remove();
        };
    }, []);

    return (
        <div className="not-found">
            <span className="not-found-code">404</span>
            <h1>Page not found</h1>
            <p>The page you are looking for doesn't exist or has been moved.</p>
            <div className="not-found-actions">
                <Button variant="contained" className="not-found-home" onClick={() => navigate("/")}>
                    Back to home
                </Button>
                <Button className="not-found-link" onClick={() => navigate("/projects")}>
                    See our projects
                </Button>
            </div>
        </div>
    );
}
